module.exports = __webpack_public_path__ + "img/icon_circle_de.62b58cb.svg";